import { take, fork, call, put, all, takeEvery } from 'redux-saga/effects';
import asyncInterface from '../../../../asyncInterface';
import history from '../../../../history/history';
import {
  fetchGrantsActivityType,
  singleExchangesType,
  fetchLazyDataType,
  fetchRecurringLazyDataType,
  cancelTxnScheduleType,
  gaRecurringDataType,
  gaAgreementDataType,
  cancelGrantsType,
  lazyLoadDataLoaderType,
  lazyLoadRecurringDataLoaderType,
  lazyLoadDataSuccessGaType,
  lazyLoadRecurringDataSuccessGaType,
  isLoadingSingleDataType,
  gaSingleDataFailureType,
  gaRecurringDataFailureType,
  gaAgreementsDataFailureType,
  cancelGrantsDataFailureType,
  lazyLoadDataFailureType,
  lazyLoadRecurringDataFailureType,
  setAllSIngleGrantsType,
  singleGrantsSuccessGaType,
  allSingleGrantsInitiateType
} from './actionTypes';

export function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.exchangeActivity.fetchAccountData(fetchPayload);
}

export function postActivityData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.exchangeActivity.postActivityData(fetchPayload);
}

export function* grantsActivitySingle(data) {
  try {
    yield put({
      type: isLoadingSingleDataType,
      payload: true
    });
    const response = yield call(fetchAccountData, data);
    yield put({
      type: singleExchangesType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: gaSingleDataFailureType,
      error
    });
  }
}

export function* grantsActivityRecurring(data) {
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: gaRecurringDataType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: gaRecurringDataFailureType,
      error
    });
  }
}

export function* grantsAgreement(data) {
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: gaAgreementDataType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: gaAgreementsDataFailureType,
      error
    });
  }
}
var cancelCount = 0;
export function* cancelExchangeWorker(data) {
  try {
    const response = yield call(postActivityData, data.payload);
    yield put({
      type: cancelGrantsType,
      count: cancelCount++,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: cancelGrantsDataFailureType,
      count: cancelCount++,
      payload: 'Failed'
    });
  }
}

export function* lazyDataFetch(data) {
  yield put({
    type: lazyLoadDataLoaderType
  });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: lazyLoadDataSuccessGaType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: lazyLoadDataFailureType,
      error
    });
  }
}

//Recurring grants lazy
export function* lazyRecurringDataFetch(data) {

  yield put({
    type: lazyLoadRecurringDataLoaderType
  });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: lazyLoadRecurringDataSuccessGaType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: lazyLoadRecurringDataFailureType,
      error
    });
  }
}
export function* setAllSIngleGrants(data) {
  yield put({
    type: allSingleGrantsInitiateType
  });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: singleGrantsSuccessGaType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: lazyLoadDataFailureType,
      error
    });
  }
}

export function* fetchAccountDataWorker(fetchPayload) {
  yield all([
    fork(grantsActivitySingle, fetchPayload.payload.metaData[0]),
    fork(grantsActivityRecurring, fetchPayload.payload.metaData[1]),
    fork(grantsAgreement, fetchPayload.payload.metaData[2])
  ]);
}

export function* fetchAccountDataWatcher() {
  yield takeEvery(fetchGrantsActivityType, fetchAccountDataWorker);
}

export function* cancelExchangeWatcher() {
  yield takeEvery(cancelTxnScheduleType, cancelExchangeWorker);
}

export function* fetchLazyDataWatcher() {
  yield takeEvery(fetchLazyDataType, fetchLazyDataWorker);
}

// Recurring grants Lazy 
export function* fetchRecurringLazyDataWatcher() {
  yield takeEvery(fetchRecurringLazyDataType, fetchRecurringLazyDataWorker);
}

export function* setSingleGrantsDataWatcher() {
  yield takeEvery(setAllSIngleGrantsType, setAllGrantsDataWorker);
}

export function* setAllGrantsDataWorker(fetchPayload) {
  yield all([fork(setAllSIngleGrants, fetchPayload.payload)]);
}

export function* fetchLazyDataWorker(fetchPayload) {
  yield all([fork(lazyDataFetch, fetchPayload.payload)]);
}

//Recurring grants lazy
export function* fetchRecurringLazyDataWorker(fetchPayload) {
  yield all([fork(lazyRecurringDataFetch, fetchPayload.payload)]);
}
export default function* grantsActivityWatcher() {
  yield all([
    fork(fetchAccountDataWatcher),
    fork(cancelExchangeWatcher),
    fork(fetchLazyDataWatcher),
    //recurring grants lazy 
    fork(fetchRecurringLazyDataWatcher),
    fork(setSingleGrantsDataWatcher)
  ]);
}
